// extracted by mini-css-extract-plugin
module.exports = {"SNA12":"SNA12_SNA12__1mct1","Scale":"SNA12_Scale__3PA5r"};